import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { MapPin, AlertTriangle } from "lucide-react";
import { ROLES, extractVenue } from "@/utils/constants";

export const MobileTeamEditDialog = ({ job, teamMembers, onAssignmentChange, onClose, getConflict, formatDate, getDisplayTitle }) => {
  if (!job) return null;
  return (
    <Dialog open={!!job} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm" data-testid="mobile-team-edit-dialog">
        <DialogHeader>
          <DialogTitle className="text-base leading-snug pr-6">{getDisplayTitle(job)}</DialogTitle>
          <div className="text-xs text-[#6b7280] space-y-0.5">
            <p>{formatDate(job.date)}</p>
            {job.location && (
              <p className="flex items-center gap-1"><MapPin className="h-3 w-3" />{extractVenue(job.location)}</p>
            )}
          </div>
        </DialogHeader>
        <div className="space-y-2.5">
          {ROLES.map(role => {
            const conflict = getConflict(job.id, job.assignments?.[role], job.date);
            return (
              <div key={role} className="flex items-center gap-3">
                <span className="w-10 text-xs font-semibold text-[#605e5e]">{role}</span>
                <div className="flex-1 relative">
                  <Select
                    value={job.assignments?.[role] || "unassigned"}
                    onValueChange={(value) => onAssignmentChange(job.id, role, value === "unassigned" ? null : value)}
                  >
                    <SelectTrigger
                      className={`w-full h-10 text-sm ${
                        conflict
                          ? 'bg-amber-100 text-amber-900 border-amber-400'
                          : job.assignments?.[role]
                            ? 'bg-[#8DA399] text-white border-[#8DA399]'
                            : 'bg-gray-100 text-[#6b7280] border-gray-200'
                      }`}
                      data-testid={`mobile-team-select-${role}`}
                    >
                      <SelectValue>
                        {job.assignments?.[role]
                          ? teamMembers.find(m => m.id === job.assignments[role])?.name || "Select"
                          : "\u2014 Unassigned \u2014"}
                      </SelectValue>
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="unassigned">{"\u2014"} Unassigned {"\u2014"}</SelectItem>
                      {teamMembers.map(member => (
                        <SelectItem key={member.id} value={member.id}>{member.name}</SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                  {conflict && (
                    <span className="absolute -top-1.5 -right-1.5 bg-white rounded-full">
                      <AlertTriangle className="h-3.5 w-3.5 text-amber-600" />
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
        <p className="text-[11px] text-gray-400">Changes save automatically.</p>
      </DialogContent>
    </Dialog>
  );
};
